import generateSegmentData from './generateSegmentData';

const trackSegmentData = ({pageName, eventName, eventData}) => {
  if (!window || !window.analytics) {
    return;
  }

  const {page, track, user} = window.analytics;
  const {href: url, pathname: path} = window.location;

  const userTraits = user ? user().traits() : {};
  const context = {
    traits: userTraits || {},
    page: {path, url},
  };
  const props = generateSegmentData(eventData);

  if (pageName) {
    page(pageName, {...props, ...userTraits, path, url});
  } else {
    track(eventName, props, context);
  }
};

export default trackSegmentData;
